export function ScorecardCollectorIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="10" y="8" width="22" height="30" rx="2" />
      <rect x="16" y="12" width="22" height="30" rx="2" fill="none" />
      <line x1="20" y1="20" x2="34" y2="20" />
      <line x1="20" y1="25" x2="34" y2="25" />
      <line x1="20" y1="30" x2="30" y2="30" />
    </svg>
  );
}
